<template>
    <!-- SECTION: Template -->
    <div>
        <!-- ANCHOR: Header -->
        <header class="header position-fixed">        
            <!-- ANCHOR: LNB -->
            <div class="lnb-wrap d-flex justify-center">
                <div class="lnb c-contanier d-flex align-center justify-space-between">
                    <div class="lnb__logo">
                        <RouterLink :to="{ name: 'HomePageSelectedLanguage', params: { lang: currentLang } }">
                            <v-img
                                :src="require('@/assets/svg/others/logo-lecos.svg')"
                                alt="LecoS Logo"
                                width="100"
                                contain
                            />
                        </RouterLink>
                    </div>

                    <!-- ANCHOR: GNB(PC) -->
                    <div
                        ref="gnbWrap"
                        class="gnb-wrap d-flex align-center justify-end justify-md-center"
                        @mouseover="addGnbActiveClass"
                        @mouseleave="removeGnbActiveClass"
                    >
                        <div
                            v-if="$vuetify.breakpoint.smAndDown"
                            class="d-flex align-center"
                        >
                            <div class="mr-5">
                                <!-- 언어 선택 버튼 -->
                                <LanguageMenu @change="setLang" />
                                <!-- // 언어 선택 버튼 -->
                            </div>
                    
                            <v-btn                            
                                icon
                                color="gray3"
                                :width="$vuetify.breakpoint.xsOnly ? 40 : 48"
                                :height="$vuetify.breakpoint.xsOnly ? 40 : 48"
                                :ripple="false"
                                plain
                                @click="toggleDrawerMenu"
                            >
                                <v-icon :size="$vuetify.breakpoint.xsOnly ? 40 : 48">
                                    fontagon-icons ft-icon ft-ic_hamburger_outline
                                </v-icon>
                            </v-btn>
                        </div>

                        <div
                            v-else
                            class="gnb d-flex"
                        >
                            <ul class="gnb__ul flex d-flex justify-space-between align-center">
                                <li
                                    v-for="(item, index) in gnbMainMenu" 
                                    :key="index"
                                    class="gnb__item"
                                >
                                    <RouterLink
                                        v-if="!isMobile"
                                        :to="{ name: item.route, params: { lang: currentLang } }"
                                        class="gnb__link d-flex align-center"
                                        @click.native="removeGnbActiveClass"
                                    >
                                        {{ item.title }}
                                    </RouterLink>

                                    <span
                                        v-else
                                        class="gnb__link d-flex align-center"
                                    >
                                        {{ item.title }}
                                    </span>

                                    <transition name="fade">
                                        <ul
                                            v-if="isGnbActive"
                                            class="smenu d-flex flex-column gap-5"
                                        >
                                            <li
                                                v-for="(sub, subIndex) in item.gnbSubMenu"
                                                :key="subIndex"
                                                class="smenu__item"
                                            >
                                                <template v-if="sub.isExternal">
                                                    <a
                                                        :href="sub.externalLink"
                                                        class="smenu__link d-inline-flex align-center"
                                                        target="_blank"
                                                        @click="removeGnbActiveClass"
                                                    >
                                                        {{ sub.title }}
                                                    </a>
                                                </template>

                                                <template v-else>
                                                    <RouterLink
                                                        :to="{ name: sub.route, params: { lang: currentLang }, query: sub.query }"
                                                        class="smenu__link d-inline-flex align-center"
                                                        @click.native="removeGnbActiveClass"
                                                    >
                                                        {{ sub.title }}
                                                    </RouterLink>
                                                </template>
                                            </li>
                                        </ul>
                                    </transition>
                                </li>
                            </ul>

                            <transition name="fade">
                                <div
                                    v-if="isGnbActive"
                                    class="gnb-wrap__background"
                                ></div>
                            </transition>
                        </div>
                    </div>

                    <!-- ANCHOR: HButtons(PC) -->
                    <div
                        v-if="$vuetify.breakpoint.mdAndUp"
                        class="h-btns d-flex gap-4 align-center"
                    >
                        <div>
                            <!-- 언어 선택 버튼 -->
                            <LanguageMenu />
                            <!-- // 언어 선택 버튼 -->
                        </div>
                        
                        <!-- 로그인 버전 선택 버튼 -->
                        <LoginMenu />
                        <!-- // 로그인 버전 선택 버튼 -->
                        
                        <v-btn
                            color="blue1"
                            :small="$vuetify.breakpoint.mdAndUp"
                            depressed
                            class="text-white1"
                            @click="navigateToContactPage"
                        >
                            {{ this.$t('header.btns.btn2') }}
                        </v-btn>
                    </div>

                    <!-- ANCHOR: GNB(Mobile) -->
                    <transition name="fade">
                        <v-overlay
                            v-if="$vuetify.breakpoint.smAndDown && isDrawerActive"
                            @click="toggleDrawerMenu"
                        ></v-overlay>
                    </transition>

                    <transition name="slide">
                        <div
                            v-if="$vuetify.breakpoint.smAndDown && isDrawerActive"
                            class="gnb-mobile-wrap"
                        >
                            <v-btn
                                icon
                                color="gray3"
                                width="32"
                                height="32"
                                :ripple="false"
                                plain
                                class="gnb-mobile-wrap__close"
                                @click="toggleDrawerMenu"
                            >
                                <v-icon size="32">
                                    fontagon-icons ft-icon ft-ic_xMark_outline
                                </v-icon>
                            </v-btn>

                            <!-- ANCHOR: HButtons(Mobile) -->
                            <div
                                v-if="$vuetify.breakpoint.smAndDown"
                                class="h-btns d-flex gap-4"
                                :class="{'mb-5': $vuetify.breakpoint.smOnly, 'mb-3': $vuetify.breakpoint.xsOnly}"
                            >
                                <!-- 로그인 버전 선택 버튼 -->
                                <LoginMenuMobile @navigate="closeDrawer" />
                                <!-- // 로그인 버전 선택 버튼 -->
                        
                                <v-btn
                                    color="blue1"
                                    :small="$vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xsOnly"
                                    depressed
                                    class="text-white1"
                                    @click="navigateToContactPage"
                                >
                                    {{ this.$t('header.btns.btn2') }}
                                </v-btn>
                            </div>

                            <ul class="gnb-mobile d-flex flex-column justify-center align-center">
                                <li
                                    v-for="(item, index) in gnbMainMenu" 
                                    :key="index"
                                    class="gnb-mobile__item"
                                >
                                    <button
                                        class="gnb-mobile__link d-flex align-center justify-space-between"
                                        @click="item.gnbSubMenu ? toggleDrawerSubMenu(item.route) : goToRouteAndCloseDrawer(item.route)"
                                    >
                                        <span class="gnb-mobile__item-text">{{ item.title }}</span>

                                        <v-btn
                                            v-if="item.gnbSubMenu"
                                            icon
                                            color="gray3"
                                            :ripple="false"
                                            plain
                                            width="24"
                                            height="24"
                                            class="mr-2"
                                        >
                                            <v-icon size="24">
                                                fontagon-icons ft-icon
                                                {{ openCurrentDrawerSubMenu(item.route) ? 'ft-ic_chevron_up_outline' : 'ft-ic_chevron_down_outline' }}
                                            </v-icon>
                                        </v-btn>
                                    </button>

                                    <transition name="slide-expand">
                                        <ul
                                            v-if="openCurrentDrawerSubMenu(item.route)"
                                            class="smenu-mobile d-flex flex-column"
                                        >
                                            <li
                                                v-for="(sub, subIndex) in item.gnbSubMenu"
                                                :key="subIndex" 
                                                class="smenu-mobile__item"
                                            >
                                                <template v-if="sub.isExternal">
                                                    <a
                                                        :href="sub.externalLink"
                                                        class="smenu-mobile__link d-flex align-center"
                                                        target="_blank"
                                                        @click="closeDrawer"
                                                    >
                                                        {{ sub.title }}
                                                    </a>
                                                </template>

                                                <template v-else>
                                                    <RouterLink
                                                        :to="{ name: sub.route }"
                                                        class="smenu-mobile__link d-flex align-center"
                                                        @click.native="closeDrawer"
                                                    >
                                                        {{ sub.title }}
                                                    </RouterLink>
                                                </template>
                                            </li>
                                        </ul>
                                    </transition>
                                </li>
                            </ul>
                        </div>
                    </transition>
                </div>
            </div>
        </header>

        <!-- ANCHOR: HeaderSpacer -->
        <div class="header-spacer"></div>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import LanguageMenu from '@/components/LanguageMenu.vue';
import LoginMenu from '@/components/LoginMenu.vue';
import LoginMenuMobile from '@/components/LoginMenuMobile.vue';
// import { isMobile } from 'mobile-device-detect';

// import { isMobile } from 'mobile-device-detect';

export default {
    name: 'Header',

    components: {
        LanguageMenu, // 컴포넌트를 등록
        LoginMenu,
        LoginMenuMobile,
    },

    // SECTION: Data Properties
    data: function () {
        return {
            isMobile: false,
            isGnbActive: false, // PC 네비 활성화
            isDrawerActive: false, // 서랍형 네비 활성화
            isDrawerSubMenuActive: null, // 서랍형 네비 서브 메뉴 활성화
            languageMenu: false,

            // isLangMenuOpen: false, // 언어 설정 메뉴 열림/닫힘 상태
            // currentLang: 'KOR', // 현재 언어 표시
            // availableLanguages: [
            //     { label: 'KOR', value: 'kor' },
            //     { label: 'ENG', value: 'eng' },
            // ],
        };
    },
    // !SECTION: Data Properties

    // SECTION: Lifecycle Hooks
    computed: {
        currentLang() {
            // 1) URL 우선
            const p = (this.$route.params.lang || '').toLowerCase();
            if (p === 'kor' || p === 'eng') return p;
            // 2) 사용자 고정값(헤더에서 선택해 저장)
            const pinned = (localStorage.getItem('siteLang') || '').toLowerCase();
            if (pinned === 'kor' || pinned === 'eng') return pinned;
            // 3) i18n.locale
            const loc = (this.$i18n.locale || '').toLowerCase();
            return loc.startsWith('en') ? 'eng' : 'kor';
        },

        gnbMainMenu() {
            return [
                {
                    title: this.$t('siteMenu.openbadge.indexMenu'), // this.$t('siteMenu.openbadge')
                    route: 'OpenbadgesPage',
                    // gnbSubMenu: false,
                    gnbSubMenu: [
                        { title: this.$t('siteMenu.openbadge.subMenu01'), route: 'OpenbadgesPage' },
                        { title: this.$t('siteMenu.openbadge.subMenu02'), route: 'BadgesGalleryPage', query: { category: 'all', search: '' } },
                    ],
                },
                {
                    title: this.$t('siteMenu.service.indexMenu'),
                    route: 'ServicePage',
                    gnbSubMenu: [
                        { title: this.$t('siteMenu.service.subMenu01'), route: 'ServicePage' },
                        { title: this.$t('siteMenu.service.subMenu02'), route: 'ManagementPage' },
                        { title: this.$t('siteMenu.service.subMenu03'), route: 'SampleBadgesV3Page' },
                        { title: this.$t('siteMenu.service.subMenu04'), isExternal: true, externalLink: 'https://www.lecos.co.kr/openbadge/verify.html' },
                    ],
                },
                {
                    title: this.$t('siteMenu.solution.indexMenu'),
                    route: 'SolutionPage',
                    gnbSubMenu: [
                        { title: this.$t('siteMenu.solution.subMenu01'), route: 'SolutionPage' },
                        { title: this.$t('siteMenu.solution.subMenu02'), route: 'EnterprisePage' },
                        { title: this.$t('siteMenu.solution.subMenu03'), route: 'AssociationPage' },
                    ],
                },
                {
                    title: this.$t('siteMenu.company.indexMenu'),
                    route: 'CompanyPage',
                    gnbSubMenu: [
                        { title: this.$t('siteMenu.company.subMenu01'), route: 'CompanyPage' },
                        { title: this.$t('siteMenu.company.subMenu02'), route: 'PressPage' },
                        { title: this.$t('siteMenu.company.subMenu03'), route: 'NoticePage' },
                    ],
                },
            ];
        }
    },

    mounted() {
        this.initLang();
        this.isMobileOrTablet();
        window.addEventListener('resize', this.handleResize);
    },

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    },
    // !SECTION: Lifecycle Hooks

    // SECTION: Methods
    methods: {
        /* ============================================================
         * ANCHOR: 언어설정
         * ============================================================ */
        initLang() {
            const urlLang = (this.$route.params.lang || '').toLowerCase();
            const pinned = (localStorage.getItem('siteLang') || '').toLowerCase();
            const long = (urlLang === 'kor' || urlLang === 'eng')
                ? urlLang
                : (pinned === 'kor' || pinned === 'eng')
                    ? pinned
                    : (this.$i18n.locale || '').toLowerCase().startsWith('en') ? 'eng' : 'kor';

            const i18nLang = long === 'eng' ? 'en' : 'ko';
            this.$i18n.locale = i18nLang;
            document.documentElement.setAttribute('lang', i18nLang);
        },
        setLang(longLang) { // 'kor' | 'eng'
            const i18nLocale = longLang === 'eng' ? 'en' : 'ko';
            // i18n + <html lang> 동기화
            this.$i18n.locale = i18nLocale;
            document.documentElement.setAttribute('lang', i18nLocale);
            // 사용자 고정값 저장
            localStorage.setItem('siteLang', longLang);
            // 현재 경로의 언어 접두사만 치환
            const cur = this.$route.path;
            const nextPath = cur.match(/^\/(kor|eng)(\/|$)/)
                ? cur.replace(/^\/(kor|eng)/, `/${longLang}`)
                : `/${longLang}`;
            this.$router.push({ path: nextPath, query: this.$route.query, hash: this.$route.hash });
        },
        // changeLang(value) {
        //     // this.$router.push({
        //     //     name: this.$route.name,
        //     //     params: { lang: value },
        //     // });
        //     // this.currentLang = value === 'kor' ? 'KOR' : 'ENG';
        //     // this.isLangMenuOpen = false;

        //     // this.$router.go();

        //     if (value === 'eng') {
        //         // 영어 선택 시 특정 URL로 이동
        //         window.location.href = 'https://www.lecos.co.kr/eng';
        //     } else {
        //         // 기본 언어 처리
        //         window.location.href = 'https://www.lecos.co.kr/kor';
        //     }
        // },
        // toggleLangMenu() {
        //     this.isLangMenuOpen = !this.isLangMenuOpen;
        // },

        /* ============================================================
         * ANCHOR: window 이벤트
         * ============================================================ */
        handleResize() {
            this.isMobileOrTablet();
        },

        /* ============================================================
         * ANCHOR: 상단 링크
         * ============================================================ */

        /* ============================================================
         * ANCHOR: 해상도 체크
         * ============================================================ */

        /* ============================================================
         * ANCHOR: 네비게이션 제어
         * ============================================================ */
        isMobileOrTablet() {
            const info = navigator.userAgent;
            var flag = false;

            if( info.indexOf('iPhone') > -1
                    || info.indexOf('Android') > -1
                    || info.indexOf('iPad') > -1
                    || info.indexOf('iPod') > -1
            ) {
                flag = true;
            }
            this.isMobile = flag;
        },
        addGnbActiveClass() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                this.$refs.gnbWrap.classList.add('is-active');
                this.isGnbActive = true;
            }
        },
        removeGnbActiveClass() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                this.$refs.gnbWrap.classList.remove('is-active');
                this.isGnbActive = false;
            }
        },
        toggleDrawerMenu() {
            this.isDrawerActive = !this.isDrawerActive;
            if (this.isDrawerActive) {
                this.isDrawerSubMenuActive = null;
            }
        },
        toggleDrawerSubMenu(menu) {
            if (this.isDrawerSubMenuActive === menu) {
                this.isDrawerSubMenuActive = null;
            } else {
                this.isDrawerSubMenuActive = menu;
            }
        },
        goToRouteAndCloseDrawer(route) {
            if (this.$route.name !== route) {
                this.$router.push({ name: route });
            }
            this.closeDrawer();
        },
        openCurrentDrawerSubMenu(menu) {
            return this.isDrawerSubMenuActive === menu;
        },
        closeDrawer() {
            this.isDrawerActive = false;
        },
        navigateToContactPage() {
            this.$router.push({ name: 'ContactPage' });
            this.closeDrawer();
        },
        navigateToUserForOpenbadge() {
            this.$router.push({ name: 'UserForOpenbadgePage' });
            this.closeDrawer();
        },

        /* ============================================================
         * ANCHOR: Animation
         * ============================================================ */
    },
    // !SECTION: Methods
};
</script>
